import Styles from './LoadingState.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const LoadingState = () => {
  return (
    <div className={Styles.container} data-testid="loading-state">
      <div data-testid="skeleton-loader">
        <Skeleton className={Styles.skeleton} active paragraph={{ rows: 5, width: '80%' }} title={false} />
      </div>
    </div>
  )
}
